<template>

  <div>
     <KTCodePreview v-bind:title="'In Hóa đơn'"
      > <template v-slot:toolbar
        > <b-form-group
          v-if="!isWholesaleInvoiceMode"
          label="Đặt khổ in mặc định"
          v-slot="{ ariaDescribedby }"
          style="font-size: small; color: black"
          > <b-form-radio-group
            v-model="printMode"
            :options="printModeOptions"
            :aria-describedby="ariaDescribedby"
            name="plain-inline"
            plain
            @change="onChangeDefaultMode()"
          ></b-form-radio-group
          > </b-form-group
        > <b-button
          variant="primary"
          size="sm"
          class="font-weight-bolder"
          @click="onClickToPrint(printMode)"
          > <i
            style="font-size: 1rem"
            class="fas fa-print"
          ></i
          >In hóa đơn </b-button
        > </template
      > <template v-slot:preview
        > <!-- Wholesale Invoice Mode --> <template v-if="isWholesaleInvoiceMode"
          >
          <hr
            class="hr-text"
            data-content="Khổ giấy A4- A5"
            style="font-weight: 600"
          />

          <div
            id="A4-wholesale-invoice"
            v-if="renderComponent"
          >
             <PrintBillWholesaleInvoice :printData="{ bill: bill }" />
          </div>
           </template
        > <!-- sale invoice Print Mode --> <template v-else
          >
          <hr
            class="hr-text"
            data-content="Khổ giấy A4- A5"
            style="font-weight: 600"
            v-show="printMode === 'A4'"
          />

          <div
            id="A4"
            v-if="renderComponent"
            v-show="printMode === 'A4'"
          >
             <PrintBill
              :bill="bill"
              :productUsages="productUsages"
            />
          </div>
           <br />
          <hr
            class="hr-text"
            data-content="Khổ giấy K80"
            style="font-weight: 600"
            v-show="printMode === 'K80'"
          />

          <div id="K80">
             <PrintBillK80
              :bill="bill"
              :productUsages="productUsages"
              v-show="printMode === 'K80'"
            />
          </div>
           </template
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import ApiService from '@/core/services/api.service'
  import { convertNumberToText } from '@/utils/common'
  import PrintBill from '../../components/bills/PrintBill'
  import PrintBillK80 from '../../components/bills/PrintBillK80.vue'
  import PrintBillWholesaleInvoice from '../../components/bills/PrintBillWholesaleInvoice.vue'
  // import PrintBillMini from '../../components/bills/PrintBillMini.vue';
  import { TIME_TRIGGER } from '@/utils/constants'
  import saveData from '@/utils/saveDataToLocal'
  import { BILL_ITEM_TYPE, AMOUNT_TYPE } from '@/utils/enum'

  export default {
    components: {
      KTCodePreview,
      PrintBill,
      PrintBillK80,
      PrintBillWholesaleInvoice,
      // PrintBillMini,
    },
    data() {
      return {
        bill: {
          billNumber: '',
          storeId: '',
          storeName: '',
          customerName: '',
          customerPhone: '',
          listBillItem: [],
          totalAmount: 0,
          textAmount: '',
          orderNote: '',
          saleName: '',
          cashierName: '',
          storeAddress: '',
          createdAt: '',
          warrantyNote: '',
          depositAmount: 0,
          transferFromOrder: 0,
          customerPoint: 0,
          totalPay: 0,
          moneyCredit: 0,
          moneyInstallment: 0,
          pointUse: 0,
          subtractPoint: 0,
          totalItemAmount: 0,
          discountValue: 0,
          customerAddress: '',
          sumQuantity: 0,
          sumTotalDiscount: 0,
          sumUnitAmount: 0,
          sumTotalAmount: 0,
        },
        productUsages: [],
        renderComponent: false,
        printMode: 'A4',
        printModeOptions: [
          { text: 'Khổ A4- A5', value: 'A4' },
          { text: 'Khổ K80', value: 'K80' },
        ],
      }
    },
    async created() {
      // Check if wholesale invoice mode
      const mode = this.$route.query.mode
      if (mode === 'A4-wholesale-invoice') {
        this.printMode = 'A4-wholesale-invoice'
      } else {
        let defaultPrintMode = saveData.getData('defaultPrintMode')
        if (!defaultPrintMode) {
          defaultPrintMode = 'A4'
          saveData.saveData('defaultPrintMode', this.printMode)
        }
        this.printMode = defaultPrintMode
      }
      const billNumber = this.$route.query.id
      await this.getBillById(billNumber)
    },
    computed: {
      isWholesaleInvoiceMode() {
        return this.$route.query.mode === 'A4-wholesale-invoice'
      },
    },
    mounted() {
      const breadcrumbTitle = this.isWholesaleInvoiceMode ? 'In hóa đơn bán buôn' : 'In hóa đơn'
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Hóa đơn', route: '/bills' },
        { title: breadcrumbTitle },
      ])
    },
    methods: {
      getBillById: async function (billNumber) {
        this.renderComponent = false
        await ApiService.get(`v1/bills/${billNumber}`).then((response) => {
          const { data } = response.data
          const bill = this.mappingBill(data)
          this.productUsages = this.handleProductUsage(bill.listBillItem)
          this.bill = bill
          this.renderComponent = true
        })
        // this.onClickToPrint(this.printMode);
      },
      mappingBill(data) {
        const totalPay = this.calcTotalPay(data)
        const amountConvertText = convertNumberToText(totalPay)
        const amountTextUpperCase = this.upperCaseFirstLetter(amountConvertText)
        const billCreteria = this.calcSumCreteria(data)
        return {
          listBillItem: this.mappingBillItems(data.billItems),
          billNumber: data.billNumber,
          storeId: data.storeId,
          storeName: data.storeName,
          storeAddress: data.storeAddress,
          storeTypeName: 'CLICKBUY',
          storeType: data.storeType,
          storeHotline: data.storeHotline,
          customerName: data.customerName,
          customerPhone: data.customerPhone,
          totalAmount: data.totalAmount,
          orderNote: data.customerNote,
          saleName: data.saleName,
          cashierName: data.cashierName,
          createdAt: data.createdAt,
          warrantyNote: data.warrantyNote,
          depositAmount: data.depositAmount,
          transferFromOrder: data.transferFromOrder,
          customerPoint: data.customerPoint,
          moneyInstallment: data.moneyInstallment,
          moneyCredit: data.moneyCredit,
          subtractPoint: data.subtractPoint ? data.subtractPoint : 0,
          pointUse: data.pointToMoney ? data.pointToMoney : 0,
          totalItemAmount: data.totalItemAmount,
          discountValue: data.discountValue,
          customerAddress: data.customerBillAddress,
          totalPay: totalPay,
          textAmount: amountTextUpperCase,
          customerShipFee: data.customerShipFee,
          conversionFee: data.conversionFee,
          sumQuantity: billCreteria.quantity,
          sumTotalDiscount: billCreteria.discount,
          sumUnitAmount: billCreteria.unitAmount,
          sumTotalAmount: data.totalAmount,
          customerCompanyName: data.customerCompanyName,
          customerTaxCode: data.customerTaxCode || data.taxCode || '',
          customerBillAddress: data.customerBillAddress,
          receiverAddress: data.receiverAddress,
          receiverMobile: data.receiverMobile,
          receiverName: data.receiverName,
          customerRepresentativeName: data.customerRepresentativeName,
          customerRepresentativeJobTitle: data.customerRepresentativeJobTitle,
          taxCode: data.taxCode,
          einvoice: data.einvoice,
        }
      },
      calcSumCreteria(data) {
        const sumCreteria = {
          quantity: 0,
          discount: 0,
          unitAmount: 0,
          totalAmount: 0,
        }
        if (!data) {
          return sumCreteria
        }
        data.billItems.forEach((item) => {
          //  rewrite some properties
          item.price = item.productPrice
          // discount/đơn vị: ưu tiên discountUnitAmount (discountAmount là chiết khấu cả dòng).
          item.discount =
            item.discountUnitAmount != null ? item.discountUnitAmount : item.discountAmount
          //  sum quantity
          sumCreteria.quantity += item.quantity
          //  sum discount
          if (
            (item.billItemType === BILL_ITEM_TYPE.PRODUCT ||
              item.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION) &&
            item.discountAmount > 0
          ) {
            if (item.discountType === AMOUNT_TYPE.MONEY) {
              sumCreteria.discount += item.discount * item.quantity
            } else if (item.discountType === AMOUNT_TYPE.PERCENT) {
              // discount price = (percentage discount * product price) / 100 (%)
              sumCreteria.discount += ((item.discountAmount * item.price) / 100) * item.quantity
            }
          }
          //  sum unit price
          if (
            item.billItemType === BILL_ITEM_TYPE.PRODUCT ||
            item.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION
          ) {
            sumCreteria.unitAmount += item.price * item.quantity
          }
        })
        sumCreteria.totalAmount = sumCreteria.unitAmount - sumCreteria.discount

        return sumCreteria
      },
      mappingBillItems(billItems) {
        let stt = 0
        return billItems.reduce((result, element) => {
          if (element.billItemType === BILL_ITEM_TYPE.PRODUCT) stt++

          const productPrice = element.productPrice || 0
          const discountType = Number(element.discountType) || AMOUNT_TYPE.MONEY
          // discountAmount của bill detail là chiết khấu cả dòng; discountUnitAmount là chiết khấu/đơn vị.
          const perUnitDiscount =
            element.discountUnitAmount != null
              ? element.discountUnitAmount
              : element.discountAmount
          let discountItemAmount = perUnitDiscount

          if (discountType === AMOUNT_TYPE.PERCENT && perUnitDiscount <= 100) {
            discountItemAmount = (productPrice * perUnitDiscount) / 100
          }

          const discountAmountValue = discountItemAmount * element.quantity

          const billItem = {
            stt: stt,
            id: element.productId,
            name: element.productName,
            code: element.productCode,
            price: productPrice,
            type: element.productType,
            quantity: element.quantity,
            imeiCode: element.imeiCode,
            totalPrice: element.quantity * productPrice - discountAmountValue,
            discount: discountItemAmount,
            discountAmountValue: discountAmountValue,
            comboItems: element.listProductInCombo,
            billItemType: element.billItemType,
            discountAmount: element.discountAmount,
            discountType: discountType,
            productNote: element.productNote ? element.productNote.trim() : null,
            warrantyMonthNo: element.warrantyMonthNo,
            totalAmountItem: 0,
          }
          billItem.totalAmountItem = this.calTotalAmountItem(billItem)
          result.push(billItem)

          return result
        }, [])
      },
      handleProductUsage(items) {
        const productUsages = items.reduce((result, product) => {
          const item = result[product.productId]
          const productNote = product.productNote
          if (!item && productNote) {
            result[product.productId] = {
              productId: product.productId,
              productName: product.productName,
              note: productNote,
            }
          }
          return result
        }, {})
        return Object.values(productUsages)
      },
      calcTotalPay(data) {
        const sum = [
          'depositAmount',
          'transferFromOrder',
          'moneyCredit',
          'moneyInstallment',
          'pointToMoney',
        ].reduce((result, item) => {
          const amount = data[item] || 0
          return result + amount
        }, 0)
        const conversionFee = data.conversionFee || 0
        const totalPay = data.totalAmount - sum + data.customerShipFee + conversionFee

        return totalPay
      },
      upperCaseFirstLetter(text) {
        return text.charAt(1).toUpperCase() + text.slice(2).toLowerCase()
      },
      printData(mode, stylePrint) {
        const printNode = document.getElementById(mode)
        const prtHtml = printNode ? printNode.outerHTML : ''
        const bodyClass = mode === 'K80' ? 'print-k80-body' : ''
        let stylesHtml = ''
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML
        }

        // Open the print window
        const WinPrint = window.open(
          '',
          '',
          'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
        )
        WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          ${stylesHtml}
          ${stylePrint}
        </head>
        <body class="${bodyClass}">`)
        WinPrint.document.write(`${prtHtml}
        </body>
      </html>`)

        WinPrint.document.close()
        WinPrint.focus()
        setTimeout(function () {
          WinPrint.print()
        }, TIME_TRIGGER)
      },
      formatMoney(number) {
        return new Intl.NumberFormat('vn-VN').format(number)
      },
      calTotalAmountItem(item) {
        // item.discount luôn là chiết khấu trên mỗi đơn vị nên nhân số lượng cho cả 2 loại.
        const result = item.price * item.quantity - item.discount * item.quantity
        return this.formatMoney(result)
      },
      getStylePrint() {
        if (this.isWholesaleInvoiceMode) {
          return `<style>
            @media print {
              @page { size: A4; margin: 10mm; }
            }
            .font-size-print { font-size: 11px !important; color: black; }
            .font-size-gift { font-size: 10px !important; color: black; }
            .imei-cell p {
              overflow-wrap: break-word !important;
              white-space: normal !important;
              line-height: 1.4 !important;
            }
            .table-bordered-print th, .table-bordered-print td {
              border: 0.5px solid #474545 !important;
              padding: 3px 5px !important;
            }
          </style>`
        }
        if (this.printMode === 'K80') {
          return `<style>
           html,
           body {
             width: 107mm !important;
             min-width: 107mm !important;
             max-width: 107mm !important;
             height: 297mm !important;
             min-height: 297mm !important;
             margin: 0 !important;
             padding: 0 !important;
             overflow: visible !important;
             background: #fff !important;
             font-family: Arial, Helvetica, sans-serif;
           }
           .font-size-print {font-size: 14px !important;}
           .font-size-product-info {font-size: 14px !important;}
           .font-size-price {font-size: 16px !important; font-weight: 700 !important;}
           .text-download-app {font-size: 12px !important; font-weight: 500 !important; margin-top: 4px;}
           body.print-k80-body,
           body.print-k80-body > div,
           body.print-k80-body #K80,
           body.print-k80-body .item-print,
           body.print-k80-body .k80-invoice {
             width: 100% !important;
             min-width: 100% !important;
             max-width: 100% !important;
             margin: 0 !important;
           }
           body.print-k80-body {
             display: block !important;
             position: relative !important;
           }
           body.print-k80-body #K80,
           body.print-k80-body .item-print,
           body.print-k80-body .k80-invoice {
             display: block !important;
           }
           body.print-k80-body #K80 {
             width: 100% !important;
             max-width: 100% !important;
             margin-left: 0 !important;
           }
           body.print-k80-body .k80-invoice {
             padding: 6px 1mm 8px !important;
             box-sizing: border-box !important;
           }
           @media print {
             @page {
               size: 107mm 297mm;
               margin: 0;
             }
             html,
             body {
               width: 107mm !important;
               min-width: 107mm !important;
               max-width: 107mm !important;
               height: 297mm !important;
               min-height: 297mm !important;
               margin: 0 !important;
               padding: 0 !important;
               overflow: visible !important;
               background: #fff !important;
             }
           }
           </style>
           `
        }
        return `<style>
                @media print {
                  @page { size: A5 landscape; margin: 8mm; }
                }
                *, *::before, *::after { box-sizing: border-box; }
                body { margin: 0; padding: 0; overflow-x: hidden; }
                /* Xóa margin inline của wrapper div để không tràn ngang */
                #A4 > div { margin-left: 0 !important; margin-right: 0 !important; padding: 0 8px; width: 100% !important; }
                .bill-meta-row {
                  display: flex !important;
                  flex-wrap: nowrap !important;
                  gap: 16px;
                  margin-top: 16px;
                }
                .bill-meta-col {
                  min-width: 0;
                }
                .bill-meta-col--left {
                  flex: 0 0 66.666% !important;
                  width: 66.666% !important;
                  max-width: 66.666% !important;
                }
                .bill-meta-col--right {
                  flex: 0 0 33.333% !important;
                  width: 33.333% !important;
                  max-width: 33.333% !important;
                }
                .bill-meta-row p {
                  margin-bottom: 4px;
                }
                .font-size-print { font-size: 13px !important; color: black; }
                .font-size-gift { font-size: 12px !important; color: black; }
                .font-size-name { font-size: 13px !important; color: black; }
                .font-size-warranty { font-size: 15px !important; color: black; }
                .font-size-product-info { font-size: 13px !important; color: black; }
                .font-size-price { font-size: 20px !important; font-weight: bold !important; }
                .text-download-app { font-size: 12px !important; font-weight: 500 !important; margin-top: 4px; }
                .item-print { width: 100% !important; margin-left: 0 !important; }
                table.table-bordered-print {
                  width: 100% !important;
                  border-collapse: collapse !important;
                  table-layout: auto !important;
                }
                table.table-bordered-print th,
                table.table-bordered-print td {
                  border: 0.5px solid #474545 !important;
                  padding: 4px 6px !important;
                  word-break: break-word !important;
                }
              </style>`
      },
      onClickToPrint(mode) {
        if (this.isWholesaleInvoiceMode) {
          this.printMode = 'A4-wholesale-invoice'
          const stylePrint = this.getStylePrint()
          this.printData('A4-wholesale-invoice', stylePrint)
        } else {
          this.printMode = mode
          const stylePrint = this.getStylePrint()
          this.printData(mode, stylePrint)
        }
      },
      onChangeDefaultMode() {
        saveData.saveData('defaultPrintMode', this.printMode)
      },
    },
  }
</script>

